import WhatWeDoMainContent from "./WhatWeDoContent";

export default WhatWeDoMainContent;